import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useAppState } from '../state/AppProvider';
import { ChatHistoryListItem } from './ChatHistoryListItem';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4, 2),
    color: theme.palette.text.secondary,
  },
}));

export const ChatHistoryList: React.FC = () => {
  const classes = useStyles();
  const { state } = useAppState();

  if (state.chatHistory.length === 0) {
    return (
      <Box className={classes.emptyState}>
        <Typography variant="body2">No conversations yet</Typography>
        <Typography variant="caption">
          Start a new chat to begin
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.container}>
      {state.chatHistory.map(conversation => (
        <ChatHistoryListItem
          key={conversation.id}
          conversation={conversation}
        />
      ))}
    </Box>
  );
};

